import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import MCElement from '../common/MCElement'

import avatarPlaceholder from '../../assets/images/mock/default-profile-icon.png'

import colors from '../../assets/styles/globals.scss'
import classes from './StudentItem.module.scss'

const StudentItem = ({ student, isSelected, onSelect, joined, enrolled }) => {
  const { t } = useTranslation()
  const disabled = joined || enrolled

  return (
    <div
      role='button'
      tabIndex='0'
      onClick={onSelect}
      onKeyDown={(e) => { e.key === 'Enter' && onSelect() }}
      className={classNames('d-flex align-items-center', classes.student, { [classes.disabled]: disabled })}
    >
      <div className={classes.inputWrapper}>
        <MCElement
          type='radio'
          primaryColor={!disabled ? (isSelected ? colors.secondaryColor : colors.lightNavy) : colors.lighterNavy}
          isSelected={isSelected}
          disabled={disabled}
        />
      </div>
      <div className='smaller-round-image-wrapper'>
        <img
          alt={t('students.avatarAlt')}
          className='round-image'
          src={student.avatar?.fileUrl || avatarPlaceholder}
        />
      </div>
      <div>
        <p className={classes.studentName}>
          {student.firstName} {student.lastName} {enrolled && t('students.item.registered')} {joined && t('students.item.waitlisted')}
        </p>
      </div>
    </div>
  )
}

StudentItem.propTypes = {
  student: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.shape({
      fileUrl: PropTypes.string,
    }),
  }).isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  joined: PropTypes.bool,
  enrolled: PropTypes.bool,
}

export default StudentItem
